export enum UploadSourceType {
  WebCam = 'WebCam',
  File = 'File'
}
